<template>
  <div>
    <el-config-provider :locale='zhCn'>
      <div>
        <headerTemplate v-if='route.meta.showHeader'></headerTemplate>
      </div>
      <div class='flex'>
        <div style='width: max-content' v-if='route.meta.showMenu'>
          <leftMenuTemplate></leftMenuTemplate>
        </div>
        <div class='main-body' style='flex: 1;width: 0;'>
          <router-view></router-view>
        </div>
      </div>
    </el-config-provider>
  </div>
</template>

<script setup>
//处理element组件提示英文
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import headerTemplate from './components/sys_template/header_nav.vue'
import leftMenuTemplate from './components/sys_template/left_menu.vue'
import { ref, onBeforeUnmount, onMounted } from 'vue'
import { setCache } from './common/js/cache.js'
import { useRoute } from 'vue-router'
import { aryGroupTwo } from '@/common/js/comjs'

const route = useRoute()

/**
 * 解决ERROR ResizeObserver loop completed with undelivered notifications.
 * F12页面大小变化--报错处理
 * @param fn
 * @param delay
 * @returns {(function(): void)|*}
 */
let debounce = (fn, delay) => {
    let timer = null
    return function() {
      let context = this
      let args = arguments
      clearTimeout(timer)
      timer = setTimeout(function() {
        fn.apply(context, args)
      }, delay)
    }
}

/**
 * 存储系统时间戳用于检验是否一直打开系统
 * 时间超过1S自动退出系统
 * @type {Ref<UnwrapRef<null>>}
 */
const timeIndex = ref(null)
timeIndex.value = setInterval(() => {
  let thisTime = Math.floor(new Date().getTime() / 1000)
  setCache('systemTime', thisTime, 5000)
}, 1000)

onMounted(()=>{
  /*let a = [113.944796,25.441724,113.99327308,25.56339825,113.913816,25.703759,113.91458907,25.70565617,113.960577,25.778299,113.960435,25.778427,113.960262,25.794214,113.960313,25.794535,114.008574,25.870124,114.010271,25.871089,114.020722,25.972185,114.293035,26.034906,114.37506,26.116516,114.428708,26.082042,114.576319,26.235564,114.716352,26.162035,114.910507,26.211933,115.090586,26.150154,115.04514,26.197156,115.091142,26.266931,115.026526,26.359456,115.096162,26.487733,115.228253,26.517852,115.336322,26.673796,115.526722,26.695416,115.546753,26.648965,115.673138,26.641862,115.731568,26.711299,115.675043,26.772791,115.705525,26.849726,115.785426,26.804119,115.935357,26.965057,116.007482,27.112306,116.122541,27.134769,116.18906,27.017216,116.118609,26.727416,116.272389,26.655887,116.239157,26.548682,116.306623,26.499069,116.375513,26.50904,116.45193,26.598933,116.538967,26.561232,116.610771,26.476992,116.630927,26.478275,116.601404,26.372937,116.553732,26.365428,116.550254,26.398257,116.534577,26.40077,116.494656,26.369218,116.498242,26.366398,116.454462,26.333094,116.448304,26.328289,116.420607,26.280926,116.415081,26.278429,116.401811,26.274866,116.399044,26.273155,116.395354,26.201873,116.393867,26.199678,116.399773,26.197704,116.398496,26.192583,116.410347,26.159723,116.476297,26.172698,116.489359,26.129017,116.489612,26.12664,116.461948,26.092915,116.453963,26.086619,116.436461,26.075277,116.426619,26.068472,116.421737,26.065677,116.418229,26.054559,116.408691,26.049497,116.401336,26.046144,116.400118,26.03308,116.367942,25.961836,116.130678,25.858695,116.175424,25.749466,116.12944026,25.75871285,116.06022135,25.69467471,116.002034,25.304839,115.855583,25.209421,115.928808,25.048092,115.87341231,25.0202496,115.92426348,24.96410018,115.873329,24.972832,115.892579,24.937102,115.90076481,24.87530619,115.82425957,24.9088012,115.78253824,24.86279048,115.75647054,24.74813011,115.8084585,24.69694479,115.76126777,24.66876554,115.84352501,24.56238489,115.6876367,24.5455504,115.67170024,24.60474248,115.57366422,24.61716724,115.52533878,24.71631155,115.40629227,24.79286665,115.36011747,24.73478549,115.27802195,24.75422162,115.12053594,24.66462804,115.05406861,24.70999831,115.02488611,24.66903839,114.91309591,24.66490859,114.86882948,24.56248517,114.84901218,24.60238271,114.73562957,24.61327388,114.70515799,24.52605045,114.66524001,24.58368663,114.59237232,24.53800245,114.53170929,24.55889668,114.4283326,24.48610796,114.39024582,24.56404676,114.17454477,24.64550411,114.1697384,24.68958395,114.33422706,24.74700874,114.39580846,24.95140893,114.50991447,25.00274334,114.56199624,25.07839637,114.73357379,25.11986953,114.72533571,25.15929522,114.72523726,25.16033903,114.6800223,25.19451923,114.74883967,25.23279856,114.71432597,25.31548141,114.63463456,25.32582963,114.54038304,25.4170862,114.38148697,25.31587174,114.13843512,25.31090253,114.03787799,25.2502189,114.04429605,25.38570805,113.98746028,25.40367035,114.00312804,25.44243538]
  let b = aryGroupTwo(a);
  console.log(b);*/
});

/**
 * 页面注销时关闭定时器
 */
onBeforeUnmount(() => {
  if (timeIndex.value !== '') {
    clearInterval(timeIndex.value)
  }
  if (window.ResizeObserver !== undefined && window.ResizeObserver !== null && window.ResizeObserver !== '') {
    const _ResizeObserver = window.ResizeObserver
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        callback = debounce(callback, 16)
        super(callback)
      }
    }
  }
})

</script>

<style>
body, html {
  padding: 0;
  margin: 0;
}

#app {
  font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--zl-body-bg-color);
  font-size: var(--zl-body-font-size);
  font-weight: 400;
  min-height: 100vh;
  color: var(--zl-text-color);
}

.flexlr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flexl {
  display: flex;
  align-items: center;
}

.flexlw {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.flex {
  display: flex;
}

.table_2row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}

.table_row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: left;
  word-break: break-all;
}

.underline {
  cursor: pointer;
  color: #0077ff;
  text-decoration: underline;
}

.el-table {
  --el-table-border-color: var(--zl-table-border-color) !important;
  --el-table-header-bg-color: var(--zl-table-header-bg-color) !important;
  --el-table-header-text-color: var(--zl-table-header-text-color) !important;
  --el-table-row-hover-bg-color: var(--zl-table-row-hover-bg-color) !important;
  --el-table-current-row-bg-color: var(--zl-table-row-active-bg-color) !important;
  --el-table-bg-color: var(--zl-table-bg-color) !important;
  --el-table-text-color: var(--zl-table-text-color) !important;
  --el-table-tr-bg-color: var(--zl-table-bg-color) !important;
}

.el-table--border .el-table__inner-wrapper:after, .el-table--border:after, .el-table--border:before, .el-table__inner-wrapper:before, .el-table__border-bottom-patch, .el-table__border-left-patch {
  background-color: var(--zl-table-border-color) !important;
}

.el-pagination {
  --el-pagination-border-radius: 0px;
  --el-pagination-button-bg-color: #fafafa;
}

.el-pager li {
  margin: 0 0 0 -1px !important;
  border: 1px solid #dddddd;
  padding: 6px 12px;
}

.el-pagination > .is-last {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  margin: 0 0 0 -1px !important;
  border: 1px solid #dddddd;
  font-size: 13px;
  padding: 6px 12px;
}

.el-pagination > .is-first {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  margin: 0 -1px 0 0 !important;
  border: 1px solid #dddddd;
  font-size: 13px;
  padding: 6px 12px;
}

.el-pager li.is-active {
  border-color: var(--zl-primary-bg-color);
  font-weight: normal;
}

.zmr_icon_i {
  font-size: inherit !important;
}

.zl_scrollbar::-webkit-scrollbar {
  display: none;
}

.el-form-item {
  margin-bottom: var(--zl-box-padding);
}

.el-button--small {
  padding: var(--zmr-table-small-buttom-pd, 5px 11px) !important;
}

.el-button + .el-button {
  margin-left: var(--zmr-table-small-buttom-margin, var(--zl-box-padding)) !important;;
}

.table_body_container .el-button + .el-button {
  margin-left: 0 !important;
  padding: 0 5px !important;
}
.el-table .cell{
  padding: 0 5px;
}
.hidden-row {
  display: none !important;
}

:root{
  --el-text-color-regular:var(--zl-text-color) !important;
}
</style>
